export const colorSchemes = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const

export const colorSchemesList = Object.values(colorSchemes)
